import i18n from "../../../../constants/i18n";
import { USER_LOG_IN_HEADERS } from "../../../../constants/table-custom-headers/User";
import getUserLoginStore from "../../../../stores/user-store/login-store";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import Et3Table from "../../../../core/et3-table";

const UserLoginData = withLiteObserverAndTheme(() => {
  const loginData = getUserLoginStore().userLoginDataOrdered.get();

  return (
    <Et3Table
      columns={USER_LOG_IN_HEADERS}
      title={i18n.get("USER_LOGIN_TABLE")}
      rows={loginData}
      shouldBeFlagged={false}
      titleKey={"USER_LOGIN_TABLE"}
    />
  );
});
export default UserLoginData;
